module.exports = __webpack_public_path__ + "img/1545006710.d94a8429.jpg";